<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-8 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('association.Association_info')" :class="activeStep >= 0 ? activeClass : ''"
                                                @click="activeStep = 0">
                                                <span>{{ $t('association.Association_info') }}</span>
                                            </button>                                            
                                            <button class="multisteps-form__progress-btn" type="button" :title="('association.Address')"
                                                :class="activeStep >= 1 ? activeClass : ''" @click="activeStep = 1">
                                                {{ $t('association.Address') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="('association.Web_and_email_info')"
                                                :class="activeStep >= 2 ? activeClass : ''" @click="activeStep = 2">
                                                {{ $t('association.Web_and_email_info') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="('association.Logo_image')"
                                                :class="activeStep >= 3 ? activeClass : ''" @click="activeStep = 3">
                                                {{ $t('association.Logo_image') }}
                                            </button>                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form class="multisteps-form__form" @submit.prevent="submitForm">
                                        <association-info 
                                            v-if="activeStep === 0" 
                                            :class="activeStep === 0 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep"
                                            @update:formData="updateFormData"
                                        />
                                        <Address 
                                            v-if="activeStep === 1" 
                                            :class="activeStep === 1 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                        />
                                        <WebEmailInfo 
                                            v-if="activeStep === 2" 
                                            :class="activeStep === 2 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep" 
                                            @update:formData="updateFormData"
                                        />
                                        <logo-image
                                          v-if="activeStep === 3"
                                          :class="activeStep === 3 ? activeClass : ''"
                                          :formData="formData"                                          
                                          ref="logoimageSection"
                                          :emitter="emitter"
                                        />                                        
                                        <div class="button-row d-flex">
                                            <button v-if="activeStep === 3" @click="saveForm" class="btn mb-0 btn-sm bg-gradient-success null null ms-auto" type="button">{{ $t('common.Save') }}</button>
                                        </div>                                      
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import axios from 'axios';
import mitt from 'mitt';
import AssociationInfo from './components/AssociationInfo.vue';
import WebEmailInfo from './components/WebEmailInfo.vue';
import Address from './components/Address.vue';
import LogoImage from './components/LogoImage.vue';

export default {
  name: 'Association_create_page',
  components: {
    AssociationInfo,
    WebEmailInfo,
    Address,
    LogoImage
  },
  data() {
    return {
      emitter: mitt(),
      activeStep: 0,
      activeClass: 'js-active position-relative',
      formSteps: 5,
      formData: {
        name: '',
        abbreviation: '',
        chamberOfCommerceNo: '',
        phoneNumber: '',
        mobileNumber: '',
        address: '',
        houseNumber: '',
        city: '',
        zipcode: '',
        rvoRelationnumber: '',
        email: '',
        websiteURL: '',
        country: 'Nederland',
        logoImage: null
      },
      uploadUrl: 'https://httpbin.org/post', // Replace with your actual upload URL
    };
  },
  mounted() {
    console.log('Registering emitter event listener');
    this.emitter.on('logoImageUploaded', this.handleLogoImageUploaded);    
  },
  beforeUnmount() {
    this.emitter.off('logoImageUploaded', this.handleLogoImageUploaded);    
  },
  methods: {
    nextStep() {
      if (this.activeStep < this.formSteps - 1) {
        this.activeStep += 1;
      }
    },
    prevStep() {
      if (this.activeStep > 0) {
        this.activeStep -= 1;
      }
    },
    updateFormData(updatedData) {
      this.formData = { ...this.formData, ...updatedData };
    },
    handleLogoImageUploaded(file) {
      if (file instanceof File || typeof file === 'string') {
        console.log('logofile');
        this.formData.logoImage = file;
      }
    },    
    async uploadImageIfQueued(ref, eventName, callback) {
      if (ref?.getQueuedFiles?.().length > 0) {
        await new Promise((resolve) => {
          this.emitter.once(eventName, (file) => {
            callback(file);
            resolve();
          });
          ref.processQueue();
        });
      }
    },
    async saveForm() {
      await this.uploadImageIfQueued(this.$refs.logoimageSection, 'logoImageUploaded', this.handleLogoImageUploaded);      
      this.submitForm();
    },
    async submitForm() {
      try {
        this.$store.commit('setShowLoading', true);
        const formData = new FormData();
        Object.keys(this.formData).forEach((key) => {
          const value = this.formData[key];
          if ((key === 'logoImage') && value instanceof File) {
            //console.log('file');
            formData.append(key, value);
          } else if (value !== null && value !== undefined) {
            formData.append(key, value);
          }
        });

        const response = await axios.post('/association/save', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        if (response.data.success) {
          this.$showSuccess('errors.Success_association_created_successfully');
          
          this.$router.push('/association');
        } else {
          this.$showError('errors.Contact_system_admin');
        }
      } catch (e) {
        this.$showError(`${this.$t('errors.Contact_system_admin')}: ${e.message}`);
      } finally {
        this.$store.commit('setShowLoading', false);
      }
    },
  },
};
</script>

<style>

.choices[data-type*=select-one]::after {
  display: none !important;
}


.choices__inner {
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  position: relative;
}


.choices[data-type*=select-one] .choices__inner::before {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  width: 0;
  height: 0;
  pointer-events: none;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666;
  transform: translateY(-50%);
}

/* Hide weird characters or fallback icons */
.choices__inner > *:not(.choices__item) {
  font-family: inherit !important;
  content: none !important;
}


.choices__placeholder {
  color: #999;
  font-style: italic;
}

.choices__list--single {
  padding: 0px !important;
}
</style>

